// src/pages/Info.js
import React from 'react';
import '../App.css';

const fiverrLink = "mailto:aflow.bots@gmail.com";

function Info() {
  const packages = [
    { title: 'Basic Package', price: '€54.27', details: 'Custom FAQ Chatbot • Single Language • Simple Embed Code • Delivery in 5 Days • 1 Revision' },
    { title: 'Gold Package', price: '€117.58', details: 'Everything in Basic • Multi-language Support • Advanced Q&A • 3 Revisions • Delivery in 7 Days' },
    { title: 'Interstellar Package', price: '€271.33', details: 'Everything in Gold • CRM/Database Integration • User Authentication • Pre-set Conversational Journey • Source Code Included • Unlimited Revisions' },
    { title: 'Custom Package', price: '€TBD', details: 'Tailored solutions based on your specific needs. Contact us for a quote!' }
  ];

  return (
    <div style={{ padding: '20px' }}>
      <section className="pricing">
        <h2>Our Packages</h2>
        <div className="pricing-cards">
          {packages.map(pkg => (
            <div key={pkg.title} className="card">
              <h3>{pkg.title}</h3>
              <p className="price">{pkg.price}</p>
              <p>{pkg.details}</p>
              <a href={fiverrLink} target="_blank" rel="noopener noreferrer">
                <button className="order-btn">Order {pkg.title}</button>
              </a>
            </div>
          ))}
        </div>
      </section>

      <section className="contact">
        <h2>Contact us for more information!</h2>
        <a href="mailto:aflow.bots@gmail.com" className="contact-btn">
          aflow.bots@gmail.com
        </a>
      </section>

      <footer className="footer">
        <p>© 2025 Aflow Bots</p>
      </footer>
    </div>
  );
}

export default Info;